module.exports = __webpack_public_path__ + "static/img/huanqiu.82ec708e.png";